import { HTTPMethods } from "../client/types";
import { HandlerFunction, RouteFactory } from "./types"
import { match } from "path-to-regexp";

class Router {
   protected routes: RouteFactory = {
      GET: {},
      POST: {},
      PUT: {},
      DELETE: {}
   };

   async addRoute(path: string, method: HTTPMethods, handler: HandlerFunction) {
      if (this.routes[method][path]) return
      this.routes[method][path] = {
         handler,
         test: match(path)
      }
   }

   async get(path: string, handler: HandlerFunction) {
      this.addRoute(path, 'GET', handler)
   }

   async post(path: string, handler: HandlerFunction) {
      this.addRoute(path, 'POST', handler)
   }

   async put(path: string, handler: HandlerFunction) {
      this.addRoute(path, 'PUT', handler)
   }

   async delete(path: string, handler: HandlerFunction) {
      this.addRoute(path, 'DELETE', handler)
   }
}

export default Router;